import { render, staticRenderFns } from "./EcpDetalle.vue?vue&type=template&id=9f75b042"
import script from "./EcpDetalle.vue?vue&type=script&lang=js"
export * from "./EcpDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports